import { dateTimeFormat, getDecimalNumber } from "src/utils/utils";
import styles from "./analytics.module.scss";
import { EMPTY_STRING, reportStageMapping } from "src/components/constant/constant";
import { stageColors } from "src/variable/randomColor";
import numeral from "numeral";

const keyInfoConfig = [
  { title: "Sign Up Date", key: "signUpDate", dataIndex: "signUpDate" },
  // { title: "Last Login", key: "lastLogin", dataIndex: "lastLogin" },
  {
    title: "Last Transaction",
    key: "lastTransaction",
    dataIndex: "data",
    render: (data: { last_transaction_details: { date: string; amount: string } }) =>
      dateTimeFormat(data?.last_transaction_details?.date)?.datetime
  },
  {
    title: "Last Deposit",
    key: "lastDeposit",
    dataIndex: "data",
    render: (data: { last_deposit_details: { date: string; amount: string } }) =>
      dateTimeFormat(data?.last_deposit_details?.date)?.datetime
  },
  {
    title: "Plan Type",
    key: "planType",
    dataIndex: "planType"
  },
  {
    title: "Stage",
    dataIndex: "data",
    key: "stage",
    render: (data: { stage: string }) => (
      <div className={styles.type}>
        <div
          className={styles.typeColor}
          style={{
            backgroundColor: `${reportStageMapping[data?.stage] ? stageColors[data?.stage] : EMPTY_STRING}`,
            color: `${reportStageMapping[data?.stage] ? "#ffffff" : EMPTY_STRING}`,
            fontWeight: 600
          }}
        >
          {reportStageMapping[data?.stage] || data?.stage}
        </div>
      </div>
    )
  }
];

const userAssetConfig = [
  // {
  //   title: "Internal Admin",
  //   key: "internalAdmin",
  //   dataIndex: "data",
  //   render: (data: { user_mapping: { INTERNAL_ADMIN: number } }) => data?.user_mapping?.INTERNAL_ADMIN
  // },
  {
    title: "Super Admin",
    key: "superAdmin",
    dataIndex: "data",
    render: (data: { user_mapping: { ORGANISATION_SUPER_ADMIN: number } }) =>
      data?.user_mapping?.ORGANISATION_SUPER_ADMIN
  },
  {
    title: "Participant",
    key: "participant",
    dataIndex: "data",
    render: (data: { user_mapping: { PARTICIPANT: number } }) => data?.user_mapping?.PARTICIPANT
  },
  {
    title: "Supporter",
    key: "supporter",
    dataIndex: "data",
    render: (data: { user_mapping: { SUPPORTER: number } }) => data?.user_mapping?.SUPPORTER
  },
  {
    title: "Cards Total",
    key: "cardsTotal",
    dataIndex: "data",
    render: (data: { total_cards: number }) => data?.total_cards
  },
  {
    title: "Cards Ordered (This Month)",
    key: "cardOrder",
    dataIndex: "data",
    render: (data: { this_month_cards_count: number }) => data?.this_month_cards_count
  },
  {
    title: "Total Wallet",
    key: "totalWallet",
    dataIndex: "data",
    render: (data: { total_wallets: number }) => data?.total_wallets
  },
  {
    title: "Total Wallet Balance",
    key: "totalWalletBalance",
    dataIndex: "data",
    render: (data: { total_wallets_balance: number }) => `$${getDecimalNumber(data?.total_wallets_balance)}`
  }
];

const barOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "bottom" as const
    },
    tooltip: {
      enabled: true,
      mode: "index" as const,
      intersect: false
    },
    datalabels: {
      anchor: "end" as const,
      align: "end" as const,
      formatter: (value: number) => numeral(value).format("0.0a"),
      color: "#000"
    }
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Weeks"
      },
      grid: {
        display: true
      },
      ticks: {
        autoSkip: false,
        minRotation: 0,
        padding: 10
      },
      offset: true
    },
    y: {
      title: {
        display: true,
        text: "Amount"
      },
      ticks: {
        stepSize: 1500,
        padding: 15
      },
      interaction: {
        mode: "nearest" as const,
        intersect: true
      },
      elements: {
        bar: {
          borderRadius: 10
        }
      }
    }
  }
};

const lineOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "bottom" as const
    },
    tooltip: {
      enabled: true,
      mode: "index" as const,
      intersect: false
    },
    datalabels: {
      anchor: "end" as const,
      align: "end" as const,
      formatter: (value: number) => value.toString(),
      color: "#000"
    }
  },
  elements: {
    point: {
      // radius: 10
      // hoverRadius: 8
    }
  },
  scales: {
    x: {
      title: {
        display: true,
        text: "Weeks"
      },
      grid: {
        display: true
      },
      ticks: {
        autoSkip: false,
        minRotation: 0,
        padding: 10
      },
      offset: true
    },
    y: {
      title: {
        display: true,
        text: "Values"
      },
      ticks: {
        stepSize: 20
      },
      interaction: {
        mode: "nearest",
        intersect: true
      }
    }
  }
};

const pieOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "bottom" as const,
      align: "start" as const,
      labels: {
        boxWidth: 12,
        padding: 10
      }
    },
    labels: {
      display: false
    },
    tooltip: {
      enabled: true
    },
    datalabels: {
      display: false
    }
  }
};

export { keyInfoConfig, userAssetConfig, barOptions, lineOptions, pieOptions };
